// extracted by mini-css-extract-plugin
module.exports = {"microCard":"ProductDetails_microCard__Y23dx"};